"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalCSS = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1bwbz0n",
  styles: "*{box-sizing:border-box;}button::-moz-focus-inner{border:0;}"
} : {
  name: "1xj1cjd-getGlobalCSS",
  styles: "*{box-sizing:border-box;}button::-moz-focus-inner{border:0;};label:getGlobalCSS;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2NvbnRleHQvR2xvYmFsQ1NTLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdFIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9zdWJtb2R1bGVzL2NvbnRleHQvR2xvYmFsQ1NTLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgZ2V0R2xvYmFsQ1NTID0gKCkgPT5cbiAgY3NzKHtcbiAgICAnKic6IHtcbiAgICAgIGJveFNpemluZzogJ2JvcmRlci1ib3gnXG4gICAgfSxcbiAgICAnYnV0dG9uOjotbW96LWZvY3VzLWlubmVyJzoge1xuICAgICAgYm9yZGVyOiAwXG4gICAgfVxuICB9KTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const getGlobalCSS = () => _ref;
exports.getGlobalCSS = getGlobalCSS;